import { Controller } from "@hotwired/stimulus"
import { Tooltip } from "bootstrap"

// Initializes Bootstrap tooltips for elements with data-bs-toggle="tooltip".
// Used on admin layout (no layout_controller) so help icons appear immediately.
export default class extends Controller {
  connect() {
    this._instances = []
    this.element.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
      Tooltip.getInstance(el)?.dispose()
      this._instances.push(
        Tooltip.getOrCreateInstance(el, {
          delay: { show: 0, hide: 100 },
          trigger: "hover focus",
          container: "body",
        })
      )
    })
  }

  disconnect() {
    ;(this._instances || []).forEach((tip) => {
      try {
        tip.dispose()
      } catch (_e) {
        // Element may already be gone (Turbo navigation).
      }
    })
    this._instances = []
  }
}
